import { render, staticRenderFns } from "./BaseNotifyPlatformChange.vue?vue&type=template&id=21004d1f&scoped=true"
import script from "./BaseNotifyPlatformChange.vue?vue&type=script&lang=js"
export * from "./BaseNotifyPlatformChange.vue?vue&type=script&lang=js"
import style0 from "./BaseNotifyPlatformChange.vue?vue&type=style&index=0&id=21004d1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21004d1f",
  null
  
)

export default component.exports